var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "oneHouse" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(
          _vm._s(
            "出售" +
              "[" +
              _vm.real_estate_name +
              "." +
              _vm.build_num +
              "." +
              _vm.unit +
              "." +
              _vm.room_num +
              "]"
          )
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "closeIcon", on: { click: _vm.close } })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "part1" }, [
        _c("div", { staticClass: "oneLine" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "mgLeft" }, [
            _c("div", { staticClass: "grey" }, [_vm._v("楼盘")]),
            _vm._v(" "),
            _c("input", {
              staticClass: "input_200",
              attrs: { type: "text", disabled: "true" },
              domProps: { value: _vm.real_estate_name }
            })
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "grey" }, [_vm._v("幢座")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.build_num,
                  expression: "build_num"
                }
              ],
              staticClass: "input_200 border",
              attrs: { type: "text" },
              domProps: { value: _vm.build_num },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.build_num = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "grey" }, [_vm._v("单元")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.unit,
                  expression: "unit"
                }
              ],
              staticClass: "input_100",
              attrs: { type: "text" },
              domProps: { value: _vm.unit },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.unit = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "grey" }, [_vm._v("房号")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.room_num,
                  expression: "room_num"
                }
              ],
              staticClass: "input_100 border",
              attrs: { type: "text" },
              domProps: { value: _vm.room_num },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.room_num = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "grey" }, [_vm._v("楼层")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.floor,
                  expression: "floor"
                }
              ],
              staticClass: "input_100 border",
              attrs: { type: "text" },
              domProps: { value: _vm.floor },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.floor = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "grey" }, [_vm._v("类型")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.build_type,
                    expression: "build_type"
                  }
                ],
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.build_type = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { value: "住宅" } }, [_vm._v("住宅")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "商住" } }, [_vm._v("商住")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "商铺" } }, [_vm._v("商铺")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "写字楼" } }, [_vm._v("写字楼")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "grey" }, [_vm._v("朝向")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.toward,
                    expression: "toward"
                  }
                ],
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.toward = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { value: "东" } }, [_vm._v("东")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "南" } }, [_vm._v("南")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "西" } }, [_vm._v("西")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "北" } }, [_vm._v("北")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "南北" } }, [_vm._v("南北")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "东西" } }, [_vm._v("东西")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "grey" }, [_vm._v("年代")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.year,
                  expression: "year"
                }
              ],
              staticClass: "input_100",
              attrs: { type: "text" },
              domProps: { value: _vm.year },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.year = $event.target.value
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "oneLine" }, [
          _c("div", [_vm._v("面积")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.square,
                expression: "square"
              }
            ],
            staticClass: "input_100 mgLeft border",
            attrs: { type: "text" },
            domProps: { value: _vm.square },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.square = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "pf" }, [_vm._v("m²")]),
          _vm._v(" "),
          _c("div", { staticClass: "mgLeft" }, [_vm._v("售价")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.price,
                expression: "price"
              }
            ],
            staticClass: "input_150 mgX border",
            attrs: { type: "text" },
            domProps: { value: _vm.price },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.price = $event.target.value
                },
                _vm.toDanJia
              ]
            }
          }),
          _vm._v(" "),
          _c("div", [_vm._v("万元")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.price_dan,
                expression: "price_dan"
              }
            ],
            staticClass: "input_150 mgX",
            attrs: { type: "text" },
            domProps: { value: _vm.price_dan },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.price_dan = $event.target.value
                },
                _vm.toZongJia
              ]
            }
          }),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "mgX" }, [_vm._v("户型")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.room_count_shi,
                expression: "room_count_shi"
              }
            ],
            staticClass: "input_60 border",
            attrs: { type: "text" },
            domProps: { value: _vm.room_count_shi },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.room_count_shi = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "mgX" }, [_vm._v("室")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.room_count_ting,
                expression: "room_count_ting"
              }
            ],
            staticClass: "input_60",
            attrs: { type: "text" },
            domProps: { value: _vm.room_count_ting },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.room_count_ting = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "mgX" }, [_vm._v("厅")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.room_count_wei,
                expression: "room_count_wei"
              }
            ],
            staticClass: "input_60",
            attrs: { type: "text" },
            domProps: { value: _vm.room_count_wei },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.room_count_wei = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "mgX" }, [_vm._v("卫")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.room_count_yang,
                expression: "room_count_yang"
              }
            ],
            staticClass: "input_60",
            attrs: { type: "text" },
            domProps: { value: _vm.room_count_yang },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.room_count_yang = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "mgLeft" }, [_vm._v("阳台")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "oneLine" }, [
          _c("div", [_vm._v("来源")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.from,
                expression: "from"
              }
            ],
            staticClass: "input_200 mgX border",
            attrs: { type: "text" },
            domProps: { value: _vm.from },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.from = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", [_vm._v("装修")]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.decorate,
                  expression: "decorate"
                }
              ],
              staticClass: "mgLeft",
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.decorate = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c("option", { attrs: { value: "毛坯" } }, [_vm._v("毛坯")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "清水" } }, [_vm._v("清水")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "简装" } }, [_vm._v("简装")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "精装" } }, [_vm._v("精装")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "豪装" } }, [_vm._v("豪装")])
            ]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.decorate_year,
                  expression: "decorate_year"
                }
              ],
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.decorate_year = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c("option", { attrs: { value: "2019" } }, [_vm._v("2019")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "2018" } }, [_vm._v("2018")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "2017" } }, [_vm._v("2017")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "2016" } }, [_vm._v("2016")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "2015" } }, [_vm._v("2015")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "2014" } }, [_vm._v("2014")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "2013" } }, [_vm._v("2013")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "2012" } }, [_vm._v("2012")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "2011" } }, [_vm._v("2011")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "2010" } }, [_vm._v("2010")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "2009" } }, [_vm._v("2009")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "2008" } }, [_vm._v("2008")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "2007" } }, [_vm._v("2007")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "2006" } }, [_vm._v("2006")])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mgX" }, [_vm._v("现状")]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.who_live,
                  expression: "who_live"
                }
              ],
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.who_live = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c("option", { attrs: { value: "业主住" } }, [_vm._v("业主住")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "租客住" } }, [_vm._v("租客住")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "空置" } }, [_vm._v("空置")])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mgX" }, [_vm._v("动机")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.motive,
                expression: "motive"
              }
            ],
            staticClass: "input_400 mgX",
            attrs: { type: "text" },
            domProps: { value: _vm.motive },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.motive = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", [_vm._v("房东现状")]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.stay,
                  expression: "stay"
                }
              ],
              staticClass: "mgX",
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.stay = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c("option", { attrs: { value: "本地" } }, [_vm._v("本地")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "外地" } }, [_vm._v("外地")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "国外" } }, [_vm._v("国外")])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "part2" }, [
        _c("div", { staticClass: "control" }, [
          _c(
            "div",
            {
              class: { active: _vm.current_column === "维护", common: true },
              on: {
                click: function($event) {
                  _vm.current_column = "维护"
                }
              }
            },
            [_vm._v("维护")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: {
                active: _vm.current_column === "图片",
                mgLeft: true,
                common: true
              },
              on: {
                click: function($event) {
                  _vm.current_column = "图片"
                }
              }
            },
            [_vm._v("图片")]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.current_column === "维护",
                expression: "current_column === '维护'"
              }
            ],
            staticClass: "notes"
          },
          [
            _vm.noteList.length > 0
              ? _c(
                  "div",
                  _vm._l(_vm.noteList, function(oneNote) {
                    return _c("div", { key: oneNote.id, staticClass: "note" }, [
                      _c("div", { staticClass: "words" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(oneNote.words) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "userAndTime" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(oneNote.user + "  " + oneNote.create_time) +
                            "\n            "
                        )
                      ])
                    ])
                  }),
                  0
                )
              : _c("div", [_vm._v("\n          暂无维护记录\n        ")])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.current_column === "图片",
                expression: "current_column === '图片'"
              }
            ],
            staticClass: "images"
          },
          [
            _vm.images.length > 0
              ? _c(
                  "div",
                  _vm._l(_vm.images, function(img, index) {
                    return _c("div", { key: index, staticClass: "image" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: img.name,
                              expression: "img.name"
                            }
                          ],
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                img,
                                "name",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "主卧" } }, [
                            _vm._v("主卧")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "主卧" } }, [
                            _vm._v("次卧")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "主卧" } }, [
                            _vm._v("书房")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "主卧" } }, [
                            _vm._v("客厅")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "主卧" } }, [
                            _vm._v("餐厅")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "主卧" } }, [
                            _vm._v("厨房")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "主卧" } }, [
                            _vm._v("主卫")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "主卧" } }, [
                            _vm._v("客卫")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "主卧" } }, [
                            _vm._v("阳台")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        attrs: {
                          src: img.src,
                          preview: "5",
                          "preview-text": img.name
                        }
                      })
                    ])
                  }),
                  0
                )
              : _c("div", [_vm._v("\n          暂无图片\n        ")])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "part3" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "button",
            {
              on: {
                click: function($event) {
                  _vm.showPrompt = true
                }
              }
            },
            [_vm._v("业主")]
          ),
          _vm._v(" "),
          _c("button", { staticClass: "input-file" }, [
            _vm._v("传图\n          "),
            _c("input", {
              attrs: { type: "file", id: "input_image", multiple: "multiple" },
              on: { change: _vm.onInputFiles }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _c("button", { on: { click: _vm.save } }, [_vm._v("保存")]),
          _vm._v(" "),
          _c("button", { on: { click: _vm.close } }, [_vm._v("关闭")])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.showPrompt
      ? _c("div", { staticClass: "prompt" }, [
          _c("div", { staticClass: "prompt-in" }, [
            _c("div", { staticClass: "oneLine" }, [
              _c("div", [_vm._v("业主姓名")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.name,
                    expression: "name"
                  }
                ],
                staticClass: "input_150 mgX border",
                attrs: { type: "text" },
                domProps: { value: _vm.name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.name = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", [_vm._v("称谓")]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.appellation,
                      expression: "appellation"
                    }
                  ],
                  staticClass: "mgX",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.appellation = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "先生" } }, [_vm._v("先生")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "小姐" } }, [_vm._v("小姐")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "女士" } }, [_vm._v("女士")])
                ]
              ),
              _vm._v(" "),
              _c("div", [_vm._v("联系电话")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.phone,
                    expression: "phone"
                  }
                ],
                staticClass: "input_200 mgX border",
                attrs: { type: "text" },
                domProps: { value: _vm.phone },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.phone = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", [_vm._v("其它联系方式")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.other_way,
                    expression: "other_way"
                  }
                ],
                staticClass: "input_200 mgX",
                attrs: { type: "text" },
                domProps: { value: _vm.other_way },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.other_way = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.note,
                  expression: "note"
                }
              ],
              attrs: { cols: "80", rows: "10" },
              domProps: { value: _vm.note },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.note = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("button", { on: { click: _vm.addOneNote } }, [_vm._v("保存")])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", [_c("span", { staticClass: "saleRent" }, [_vm._v("售")])]),
      _vm._v(" "),
      _c("div", [_vm._v("地址")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _vm._v("元/"),
      _c("span", { staticClass: "pf" }, [_vm._v("m²")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3b6c8ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3b6c8ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OneHouse.vue
// module id = null
// module chunks = 